export function toggleExpandedSpecId(
  expandedIds: readonly string[],
  specId: string,
  isExpanded: boolean,
): string[] {
  const without = expandedIds.filter((id) => id !== specId);
  return isExpanded ? [...without, specId] : without;
}
